// extracted by css-extract-rspack-plugin
export default {"closeButton":"_f7981307","translucentWhite":"_a0405d3f","closeButtonDisabled":"_f1076337"};